export const DEFAULT_ERROR_HANDLER = 'DEFAULT_ERROR_HANDLER';
